<div class="w-screen h-screen relative">
    <div *ngIf="!isViewerLoaded()" class="h-full w-full flex items-center justify-center bg-black">
        <span class="text-xl text-white">Waiting to stream view...</span>
    </div>
    <app-viewers [isVrView]="true" [ngClass]="{'hidden': !isViewerLoaded()}"></app-viewers>
    <app-overlay-btns [isVrView]="true" [ngClass]="{'hidden': !isViewerLoaded()}"></app-overlay-btns>
</div>
